import { Skeleton } from 'antd';

interface LoadingSkeletonProps {
  /** Number of placeholder rows for the `list` variant. */
  rows?: number;
  /** `list` = stacked card rows (lists/tables); `detail` = a detail page shape. */
  variant?: 'list' | 'detail';
}

/**
 * Content-shaped loading placeholder built on antd Skeleton.
 *
 * Replaces bare page-level `<Spin>` loaders so the loading state matches the
 * shape of the content that follows (Phase 3 structure cleanup). Uses antd's
 * animated Skeleton — brand-neutral, theme-aware via the antd algorithm.
 */
export function LoadingSkeleton({ rows = 4, variant = 'list' }: LoadingSkeletonProps) {
  if (variant === 'detail') {
    return (
      <div className="vstack gap-16">
        <Skeleton.Input active size="large" style={{ width: 260 }} />
        <div className="info-card" style={{ padding: 20 }}>
          <Skeleton active paragraph={{ rows: 4 }} />
        </div>
        <div className="info-card" style={{ padding: 20 }}>
          <Skeleton active paragraph={{ rows: 3 }} />
        </div>
      </div>
    );
  }

  return (
    <div className="vstack gap-12">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="info-card" style={{ padding: 16 }}>
          <Skeleton active title={{ width: '40%' }} paragraph={{ rows: 2 }} />
        </div>
      ))}
    </div>
  );
}

export default LoadingSkeleton;
